/**
 * UUID Generation Utilities
 * セッション管理用のUUID生成とバリデーション
 */

/**
 * Generate UUID v4 (client-side)
 * @returns {string} UUID v4 string
 */
export const generateUUID = () => {
  // Use crypto.randomUUID if available (modern browsers)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  
  // Fallback implementation for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

/**
 * Validate UUID format
 * @param {string} uuid - UUID string to validate
 * @returns {boolean} True if valid UUID format
 */
export const isValidUUID = (uuid) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return typeof uuid === 'string' && uuidRegex.test(uuid);
};

/**
 * Generate session ID with prefix
 * @param {string} prefix - Optional prefix (default: 'sess')
 * @returns {string} Session ID with prefix
 */
export const generateSessionId = (prefix = 'sess') => {
  return `${prefix}_${generateUUID()}`;
};

/**
 * Create unique session identifier for video sessions
 * @param {string} videoId - Video ID
 * @param {string} userId - User ID 
 * @returns {string} Unique session UUID
 */
export const createVideoSessionUUID = (videoId, userId) => {
  // Generate deterministic UUID based on video, user, and timestamp
  // This helps prevent duplicate sessions for same video/user
  const timestamp = Date.now();
  const baseString = `${userId}_${videoId}_${timestamp}`;
  
  // For now, just use random UUID but could implement deterministic generation
  return generateUUID();
};